/** Stable content adapter; authoring never rewrites this module. */
import { bindContent, contentCatalog } from "../content/catalog"
export let ItemClassTypes: string[] = contentCatalog.items.classes

// Rebuild the complete table group during preparation; activation only assigns bindings.
bindContent(catalog => ({
    ItemClassTypes: catalog.items.classes,
}), next => {
    ItemClassTypes = next.ItemClassTypes
})
